// ─────────────────────────────────────────────────────────
//  Maps raw camera coordinates → CSS screen coordinates
//  and moves the #virtual-cursor element.
//
//  Returns { screenX, screenY } so callers (renderVideo.js)
//  can forward the position to other gesture handlers.
// ─────────────────────────────────────────────────────────

const cursor = document.getElementById('virtual-cursor');

// Smoothing for the cursor itself (separate from gesture EMA)
let smoothCursor = null;
const CURSOR_EMA = 0.2; // 0 = frozen, 1 = raw

export function mapToScreen(handX, handY, videoWidth, videoHeight) {
  const vw = window.innerWidth;
  const vh = window.innerHeight;

  // Camera is mirrored (scaleX(-1) in CSS), so flip X
  const x = (1 - handX / videoWidth) * vw;
  const y = (handY / videoHeight) * vh;

  return smoothMove(x, y);
}

function smoothMove(targetX, targetY) {
  // Smooth the cursor independently for a fluid feel
  if (!smoothCursor) {
    smoothCursor = { x: targetX, y: targetY };
  } else {
    smoothCursor.x = CURSOR_EMA * targetX + (1 - CURSOR_EMA) * smoothCursor.x;
    smoothCursor.y = CURSOR_EMA * targetY + (1 - CURSOR_EMA) * smoothCursor.y;
  }

  if (cursor) {
    cursor.style.left = `${smoothCursor.x}px`;
    cursor.style.top = `${smoothCursor.y}px`;
  }

  return { screenX: smoothCursor.x, screenY: smoothCursor.y };
}

export function hideCursor() {
  if (cursor) cursor.style.display = 'none';
}

export function showCursor() {
  if (cursor) cursor.style.display = 'block';
}
